// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"141":"4d8fc37f","273":"17285197","628":"9325be7f","816":"c411e52a"}[chunkId] + ".chunk.css";
};